var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06513 5.96625L2.40513 0.316245C2.31217 0.222517 2.20156 0.148123 2.07971 0.0973539C1.95785 0.0465853 1.82714 0.0204468 1.69513 0.0204468C1.56312 0.0204468 1.43241 0.0465853 1.31055 0.0973539C1.18869 0.148123 1.07809 0.222517 0.985128 0.316245C0.798877 0.503608 0.694336 0.757059 0.694336 1.02125C0.694336 1.28543 0.798877 1.53888 0.985128 1.72625L5.93513 6.72625L0.985128 11.6762C0.798877 11.8636 0.694336 12.1171 0.694336 12.3812C0.694336 12.6454 0.798877 12.8989 0.985128 13.0862C1.07774 13.1807 1.18819 13.2559 1.31006 13.3074C1.43194 13.3589 1.56282 13.3857 1.69513 13.3862C1.82744 13.3857 1.95832 13.3589 2.08019 13.3074C2.20207 13.2559 2.31251 13.1807 2.40513 13.0862L8.06513 7.43625C8.16663 7.3426 8.24764 7.22895 8.30305 7.10245C8.35846 6.97595 8.38706 6.83935 8.38706 6.70124C8.38706 6.56314 8.35846 6.42654 8.30305 6.30004C8.24764 6.17354 8.16663 6.05989 8.06513 5.96625Z",
    fill: "#A4728C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrow);
export default __webpack_public_path__ + "static/media/purple-arrow.4569e336e2039372d3e4c3258327bfd8.svg";
export { ForwardRef as ReactComponent };